import { useParams } from "react-router-dom";
import Detail from "../components/Detail";

const KitchenDetail = () => {
  const { id } = useParams();

  return <Detail id={id} type="kitchens" />
};

export default KitchenDetail;
